import { createAsyncThunk } from "@reduxjs/toolkit";
import axios, { AxiosResponse } from "axios";
import { Cookies } from "react-cookie";
import { baseUrlApi } from "../../proxy";
import CAxios from "../utils/CAxios";

interface LoginPayload {
  login: string;
  password: string;
}

interface ExchangePayload {
  points: number;
}

interface OtpNumber {
  phone: string;
}
interface QitafRedeem {
  phone: string;
  otp: number;
  amount: number;
}
interface RajhiRedeem {
  OTPValue: string;
  OTPToken: string;
  amount: string;
  language: string;
}
export const toLogin = createAsyncThunk(
  "login/toLogin",
  async (data: LoginPayload) => {
    try {
      const response = await axios.post(`${baseUrlApi}login`, data);
      return response;
    } catch (error) {
      throw error;
    }
  }
);

export const toSignup = createAsyncThunk(
  "login/toSignup",
  async ({ data, lang }: { data: any; lang: string }) => {
    try {
      const response = await axios.post(
        `${baseUrlApi}send/otp?lang=${lang}`,
        data
      );
      return response;
    } catch (error) {
      throw error;
    }
  }
);

export const toGetProfil = createAsyncThunk<AxiosResponse<any, any>, any>(
  "login/profil",
  async (lang) => {
    try {
      const response = await CAxios.get(`my/profile?lang=${lang}`);
      return response;
    } catch (error) {
      throw error;
    }
  }
);

export const toReset = createAsyncThunk("login/reset", async () => {
  try {
    return;
  } catch (error) {
    throw error;
  }
});

export const toExchangePoints = createAsyncThunk(
  "profil/toExchangePoints",
  async (data: ExchangePayload) => {
    try {
      const response = await CAxios.post(`loyalty/exchange`, data);
      return response;
    } catch (error) {
      throw error;
    }
  }
);

export const toGetMyLoyaltyHistory = createAsyncThunk(
  "profil/toGetMyLoyaltyHistory",
  async () => {
    try {
      const response = await CAxios.get(`my/loyalty/history`);
      return response;
    } catch (error) {
      throw error;
    }
  }
);

export const toGetMyWalletHistory = createAsyncThunk(
  "profil/toGetMyWalletHistory",
  async () => {
    try {
      const response = await CAxios.get(`my/wallet/history`);
      return response;
    } catch (error) {
      throw error;
    }
  }
);

export const ToEditProfile = createAsyncThunk(
  "profil/toEditProfile",
  async ({ data, lang }: { data: any; lang: string }) => {
    try {
      const response = await CAxios.post(
        `send/otp/profile?lang=${lang}`,
        data
      );
      return response;
    } catch (error) {
      throw error;
    }
  }
);

export const ToGetQitafOtp = createAsyncThunk(
  "profil/qitaf/loyalty/otp",
  async (data: OtpNumber) => {
    try {
      const response = await CAxios.post(`qitaf/loyalty/otp`, data);
      return response;
    } catch (error) {
      throw error;
    }
  }
);
export const toRedeemQitaf = createAsyncThunk(
  "profil/qitaf/loyalty/redeem",
  async (data: QitafRedeem) => {
    try {
      const response = await CAxios.post(`qitaf/loyalty/redeem`, data);
      return response;
    } catch (error) {
      throw error;
    }
  }
);
export const toGetRajhiOtp = createAsyncThunk(
  "profil/alrajhi/loyalty/otp",
  async (data: OtpNumber) => {
    try {
      const response = await CAxios.post(`alrajhi/loyalty/otp`, data);
      return response;
    } catch (error) {
      throw error;
    }
  }
);

export const toRedeemRajhi = createAsyncThunk(
  "profil/alrajhi/loyalty/redeem",
  async (data: RajhiRedeem) => {
    try {
      const response = await CAxios.post(`alrajhi/loyalty/redeem`, data);
      return response;
    } catch (error) {
      throw error;
    }
  }
);
export const toGetCountries = createAsyncThunk<AxiosResponse<any, any>, any>(
  "profile/countries",
  async (lang) => {
    try {
      const response = await axios.get(`${baseUrlApi}countries?lang=${lang}`);
      return response;
    } catch (error) {
      throw error;
    }
  }
);

export const toGetTitles = createAsyncThunk<AxiosResponse<any, any>, any>(
  "profile/titles",
  async (lang) => {
    try {
      const response = await axios.get(`${baseUrlApi}titles?lang=${lang}`);
      return response;
    } catch (error) {
      throw error;
    }
  }
);
// to reset password request
export const toResetPasswordRequest = createAsyncThunk(
  "login/reset/password",
  async ({ data, lang }: { data: any; lang: string }) => {
    try {
      const response = await axios.post(
        `${baseUrlApi}reset_password?lang=${lang}`,
        data
      );
      return response;
    } catch (error) {
      throw error;
    }
  }
);
// to contact us request
export const toContactus = createAsyncThunk(
  "login/contactus",
  async (data: any) => {
    try {
      const hasAuth = Boolean(new Cookies().get("apiKey"));
      const response = hasAuth
        ? await CAxios.post("contactus", data)
        : await axios.post(`${baseUrlApi}contactus`, data);
      return response;
    } catch (error) {
      throw error;
    }
  }
);
// to reset password
export const toResetPasswordValidate = createAsyncThunk(
  "login/reset_password/validate",
  async (data: any) => {
    try {
      const response = await axios.post(
        `${baseUrlApi}reset_password/validate`,
        data
      );
      return response;
    } catch (error) {
      throw error;
    }
  }
);
// to sign up Otp

export const toSignupOTP = createAsyncThunk(
  "login/toSignupoTP",
  async ({ data, lang }: { data: any; lang: string }) => {
    try {
      const response = await axios.post(
        `${baseUrlApi}signup?lang=${lang}`,
        data
      );
      return response;
    } catch (error) {
      throw error;
    }
  }
);
// to regenerate Otp

export const toRegenerateOtp = createAsyncThunk(
  "login/ToRegenerateOtp",
  async ({ data, lang }: { data: any; lang: string }) => {
    try {
      const response = await axios.post(
        `${baseUrlApi}regenerate/otp?lang=${lang}`,
        data
      );
      return response;
    } catch (error) {
      throw error;
    }
  }
);

// to verify reset password otp

export const toResetOtp = createAsyncThunk(
  "login/toSignupoTP",
  async (data: any) => {
    try {
      const response = await axios.post(
        `${baseUrlApi}reset_password/verify/otp`,
        data
      );
      return response;
    } catch (error) {
      throw error;
    }
  }
);
// to edit profile with otp

export const toEditProfileOtp = createAsyncThunk(
  "login/toEditProfileOtp",
  async (data: any) => {
    try {
      const response = await CAxios.post(`my/profile/edit`, data);
      return response;
    } catch (error) {
      throw error;
    }
  }
);
// to regenerate Otp for edit profile

export const toRegenerateEditOtp = createAsyncThunk(
  "login/toRegenerateEditOtp",
  async ({ data, lang }: { data: any; lang: string }) => {
    try {
      const response = await CAxios.post(
        `regenerate/otp/profile?lang=${lang}`,
        data
      );
      return response;
    } catch (error) {
      throw error;
    }
  }
);

export const toRetryReward = createAsyncThunk(
  "login/toRetryReward",
  async (data: any) => {
    try {
      const response = await CAxios.post(`loyalty/retry_phone`, data);
      return response;
    } catch (error) {
      throw error;
    }
  }
);
export const ToTransferBalance = createAsyncThunk(
  "login/ToTransferBalance",
  async (data: any) => {
    try {
      const response = await CAxios.post(`transfer_balance`, data);
      return response;
    } catch (error) {
      throw error;
    }
  }
);
